module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?398ecd6234583749f09777b00fd004b2";